export const blockIconsActionInfo = (
	<span className='material-symbols-outlined'>info</span>
);
